import React, {useEffect, useState} from 'react';
import { getServiceGroups} from "../api/HomeApi";
import {BiCategoryAlt} from "react-icons/bi";
import {TiChevronLeftOutline} from "react-icons/ti";
import {IoMdArrowDropleft} from "react-icons/io";
import {useNavigate, useParams} from "react-router-dom";
import Loading from "../../../layouts/Loading";
import {showError} from "../../../utils/toastHelper";


const ServiceGroups = (props) => {
    const [ServiceGroups, setServiceGroups] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const {id} = useParams();
    const navigate = useNavigate();
    const config = window.APP_CONFIG;

    useEffect(() => {
        const fetchGroups = async () => {
            try {

                const params = {
                    count: props.showAll ? 80 : config.service_app_settings.product_group_count,
                    special: props.showAll ? 0 : 1,
                    list: 1,
                    vendor: localStorage.getItem('_vid') === "1" ? null : localStorage.getItem('_vid'),
                    parent_id : id
                }
                const data = await getServiceGroups(params);
                setServiceGroups(data?.data || []);

            } catch (err) {
                showError( err);
            } finally {
                setLoading(false);
            }
        };
        fetchGroups();
    }, [id, config]);



    if (loading) return <Loading />;



    return (

        <section className="container  mt-4  rtl px-0  ">
            { !props.showAll && (
                <div className="row mx-1">
                    <div className="col-8 home-separator-text ">
                        <BiCategoryAlt className='mx-2'/>

                        دسته بندی ها
                    </div>
                    <div className="col-4 text-start text-small-3 text-secondary-color mt-1"
                         onClick={
                             () => {
                                 navigate(`/categories`)
                             }
                         }
                    >
                        مشاهده همه
                        <TiChevronLeftOutline className='mx-1'/>
                    </div>
                </div>
            )

            }


                    <div className="row mx-2 pb-5 my-2 product-group">
                        {
                            ServiceGroups.map(group => {
                               if (props.showAll) {
                                   return (
                                       <div className="col-12  group-image-container"
                                            key={group.id}
                                            onClick={
                                                () => {
                                                    group.child > 0 ?
                                                        navigate(`/categories/${group.id}`) :
                                                        navigate(`/services/${group.id}`)
                                                }
                                            }
                                       >
                                           <div className="row">
                                               <div className="col-3 ">
                                                   <img src={group.image} alt={group.name} className='w-100'/>
                                               </div>
                                               <div className="col-9 title">
                                                   <span className='text-big-3'>{group.name}</span>
                                                   <p className='mt-2 text-muted opacity-75  '>
                                                       {group.description.replace(/<[^>]+>/g, '')}
                                                   </p>
                                               </div>
                                           </div>
                                       </div>
                                   )

                               } else {
                                   return (
                                       <div
                                           className="col-4 col-md-2 px-1 text-center "
                                           key={group.id}
                                           onClick={
                                               () => {
                                                   group.child > 0 ?
                                                       navigate(`/categories/${group.id}`) :
                                                       navigate(`/services/${group.id}`)
                                               }
                                           }
                                       >
                                           <div className="group-image-container">
                                               <img src={group.image} alt={group.name}/>
                                               <div className="title mt-2">

                                                   {group.name.substring(0, 14)}
                                                   {
                                                       group.name.length > 14 ?
                                                           <span className='text-small-4'>
                                                    ...
                                                </span>
                                                           : ''
                                                   }
                                                   {
                                                       group.sub_categories > 0 &&
                                                       <span>
                                                <IoMdArrowDropleft/>
                                            </span>
                                                   }
                                               </div>
                                           </div>

                                       </div>
                                   )
                               }

                            })

                        }

                    </div>



        </section>
    );
};

export default ServiceGroups;